<template>
    <div class="detail-item">
        <div class="type">
            <p>
                {{ `quote-results.static.policy_includes` | __ }}
            </p>
        </div>
        <ul class="policy-details">
            <li v-for="(value, key, index) in innerProps" :key="key">
                <div>{{ `quote-results.${type}.${key}` | __ }}</div>
                <div>
                    {{ getValueOrUnlimited(value) }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        innerProps: Object,
        type: String,
        currency: String
    },
    methods: {
        getValueOrUnlimited(value) {
            if (value === null) {
                return this.$trans("quote-results.static.notAvailable");
            } else if (value === -1) {
                return this.$trans("quote-results.static.unlimited");
            } else if (value === -2) {
                return "";
            }
            return `${value} ${this.currency}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.detail-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 7px;
    width: 100%;
}

.policy-details {
    list-style: none;
    display: flex;
    flex-direction: column;
    width: 100%;

    li {
        display: flex;
        justify-content: space-between;
    }
}
</style>
